const NotificationsUI = {
  initialized: false,

  init() {
    const bell = document.getElementById("notifications-bell")
    if (!bell) return

    if (this.initialized) return
    this.initialized = true

    this.bell = bell
    this.badge = document.getElementById("notifications-badge")
    this.list = document.getElementById("notifications-list")
    this.markAllBtn = document.getElementById("notifications-mark-all")

    this.fetchNotifications()
    this.bindEvents()
  },

  bindEvents() {
    if (this.markAllBtn) {
      this.markAllBtn.addEventListener("click", (event) => {
        event.preventDefault()
        event.stopPropagation()
        this.markAllRead()
      })
    }

    if (this.list) {
      this.list.addEventListener("click", (event) => {
        const item = event.target.closest("[data-notification-id]")
        if (!item) return

        event.preventDefault()
        const notificationId = item.dataset.notificationId
        const linkPath = item.dataset.linkPath
        this.markRead(notificationId).then(() => {
          if (linkPath) window.location.href = linkPath
        })
      })
    }

    if (this.bell) {
      this.bell.addEventListener("click", () => this.fetchNotifications())
    }
  },

  fetchOptions() {
    return {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }
  },

  fetchNotifications() {
    if (!this.list) return

    fetch("/notifications", this.fetchOptions())
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then((data) => this.render(data))
      .catch(() => this.showError())
  },

  showError() {
    if (!this.list) return
    this.list.innerHTML = '<div class="dropdown-item text-muted small">No se pudieron cargar las notificaciones</div>'
  },

  render(data) {
    this.updateBadge(data.unread_count)
    if (!this.list) return

    if (!data.notifications || data.notifications.length === 0) {
      this.list.innerHTML = '<div class="dropdown-item text-muted small">No hay notificaciones</div>'
      return
    }

    this.list.innerHTML = data.notifications.map((notification) => this.itemTemplate(notification)).join("")
  },

  itemTemplate(notification) {
    const unreadClass = notification.read ? "" : "font-weight-bold bg-light"
    const time = this.formatTime(notification.created_at)

    return `
      <a href="#" class="dropdown-item notification-item ${unreadClass}"
         data-notification-id="${notification.id}"
         data-link-path="${notification.link_path || ""}">
        <div class="small text-muted">${time}</div>
        <div>${notification.title}</div>
        <div class="small text-secondary">${notification.body || ""}</div>
      </a>
    `
  },

  updateBadge(count) {
    if (!this.badge) return

    if (count > 0) {
      this.badge.textContent = count > 99 ? "99+" : count
      this.badge.classList.remove("d-none")
    } else {
      this.badge.classList.add("d-none")
    }
  },

  markRead(notificationId) {
    return fetch(`/notifications/${notificationId}/read`, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": this.csrfToken()
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then((data) => {
        this.updateBadge(data.unread_count)
        this.fetchNotifications()
      })
  },

  markAllRead() {
    fetch("/notifications/mark_all_read", {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": this.csrfToken()
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then((data) => {
        this.updateBadge(data.unread_count)
        this.fetchNotifications()
      })
  },

  handleCableMessage(data) {
    if (data.type === "new") {
      this.updateBadge(data.unread_count)
      this.fetchNotifications()
    }
  },

  formatTime(isoString) {
    const date = new Date(isoString)
    return date.toLocaleString("es-CL", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    })
  },

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute("content") : ""
  }
}

window.NotificationsUI = NotificationsUI

const bootNotifications = () => {
  NotificationsUI.initialized = false
  NotificationsUI.init()
}

document.addEventListener("DOMContentLoaded", bootNotifications)
document.addEventListener("turbolinks:load", bootNotifications)

export default NotificationsUI
